import React, { useEffect, useState } from 'react';

// Shown in the assistant bubble while we wait for the response to start
// streaming (gpt-5 can spend 10s+ reading a long transcript before the first
// token). Timed stages stay intentionally broad because we do not have a
// backend progress signal.
const STATUS_MESSAGES = [
  'Reviewing patient history...',
  'Checking prior visits...',
  'Preparing response...',
];
const STATUS_INTERVAL_MS = 5000;

/**
 * Shown while we wait for the response to start streaming. Animations live in
 * argon-dashboard-react.scss under .chat-thinking. `status`, when given (the
 * agentic chat knows what it is actually doing), replaces the timed stages.
 */
const ChatThinkingIndicator = ({ status = null }) => {
  const [statusIndex, setStatusIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setStatusIndex((i) => Math.min(i + 1, STATUS_MESSAGES.length - 1));
    }, STATUS_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="chat-thinking">
      <svg
        className="chat-thinking-mark"
        viewBox="0 0 38 24"
        width="36"
        height="22"
        aria-hidden="true"
      >
        <path
          className="chat-thinking-wave-base"
          pathLength="100"
          d="M4 13H9L12 9L16 17L20.5 5L25 13H34"
        />
        <path
          className="chat-thinking-wave-active"
          pathLength="100"
          d="M4 13H9L12 9L16 17L20.5 5L25 13H34"
        />
      </svg>
      <span className="chat-thinking-status" aria-live="polite">
        {status || STATUS_MESSAGES[statusIndex]}
      </span>
    </div>
  );
};

export default ChatThinkingIndicator;
